import { splitDisplayName } from '@shared/utils/initials';

import type { Role, User } from './types';

/** Backend `LoginResponseDTO` / refresh responses (Quarkus JSON). */
export interface BackendAuthResponse {
  accessToken: string;
  refreshToken: string;
  exp: number;
  role: Role;
  id: string;
  name: string;
  email: string;
}

/** Backend `UserProfileDTO` subset used by the UI. */
export interface UserProfileDTO {
  id: string;
  name: string;
  lastName?: string;
  email: string;
  role: Role;
}

/** Profile JSON may use camelCase or snake_case for last name. */
type UserProfilePayload = UserProfileDTO & { last_name?: string };

export function profileToUser(p: UserProfilePayload): User {
  const firstName = p.name.trim();
  const lastNameRaw = p.lastName ?? p.last_name;
  const lastName = typeof lastNameRaw === 'string' ? lastNameRaw.trim() : '';
  const name = [firstName, lastName].filter(Boolean).join(' ');
  return {
    id: p.id,
    email: p.email,
    name,
    firstName,
    lastName,
    role: p.role,
  };
}

export function userFromAuthResponse(data: BackendAuthResponse): User {
  const { firstName, lastName, displayName } = splitDisplayName(data.name);
  return {
    id: data.id,
    email: data.email,
    name: displayName,
    firstName,
    lastName,
    role: data.role,
  };
}
